import { render, staticRenderFns } from "./multi_widget_form.vue?vue&type=template&id=3dd4726c&scoped=true&"
import script from "./multi_widget_form.vue?vue&type=script&lang=js&"
export * from "./multi_widget_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4726c",
  null
  
)

export default component.exports